import { combineReducers } from 'redux';
import { defaultProductSettingsReducer } from './reducers/default-product-settings-reducer';

export default combineReducers({
  defaultProductSettingsReducer
});
